<script>
import { defineComponent } from "vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
export default defineComponent({
  data() {
    return {
      profile: {},
      profileUser: false,
    };
  },
  mounted() {
    this.consultarPerfil();
  },
  props: {
    voltar: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    toggleSidebar() {
      this.$store.state.drawer = !this.$store.state.drawer;
    },
    voltarTela() {
      window.history.back();
    },
    consultarPerfil() {
      http
        .get("cliente/perfil", {
          headers: authHeader(),
        })
        .then((response) => {
          this.profile = response.data.pessoa;
          this.profile.email = response.data.email;
          this.profileUser = true;
        })
        .catch((error) => {
          console.error("Erro ao carregar perfil:", error);
        });
    },
  },
});
</script>
<template>
  <nav>
    <div class="d-flex align-center">
      <v-icon @click="toggleSidebar" color="white" class="mr-3 cursor-pointer">
        {{ $store.state.drawer ? "mdi-chevron-left" : "mdi-menu" }}
      </v-icon>
    </div>
    <ul class="nav-list">
      <li>
        <a
          @click.prevent="voltarTela()"
          v-if="voltar"
          class="opacity cursor-pointer"
          >Voltar</a
        >
        <a v-else-if="profileUser">Seja bem-vindo(a), {{ profile.nome }}!</a>
        <a v-else>Seja bem-vindo(a)!</a>
      </li>
    </ul>
  </nav>
</template>

<style scoped>


a {
  color: #fff;
  text-decoration: none;
  transition: 0.3s;
  font-weight: 600;
  font-size: 16px;
}

.nav-list a.opacity:hover {
  opacity: 0.5;
}

nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #343f53;
  min-height: 8vh;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.nav-list {
  list-style: none;
  display: flex;
  gap: 1rem;
}

.nav-list li {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

@media screen and (max-width: 815px) {
  nav {
    padding: 1.5rem 4rem;
  }
  img {
    display: none;
  }
}
</style>
